'use client'
import React, { useState } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import Gallery from '@components/Gallery'
import Video from '@components/Video'
import VideoGallery from '@components/VideoGallery'
import { IoMdPhotos } from 'react-icons/io'

// Import Swiper styles
import "swiper/css";
import 'swiper/css/navigation';

const PropertyFloorplansGallery = ({ gallery, altName = '', dictionary }) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isVideoPopupOpen, setVideoPopupOpen] = useState(false);

    const openPopup = (index) => {
        if (gallery && gallery.length > 0) {
            setActiveSlide(index)
            setPopupOpen(true);
            setVideoPopupOpen(false);
        }
    };

    const openVideoPopup = () => {
        setVideoPopupOpen(true);
        setPopupOpen(false);
    };

    const closePopup = () => {
        setPopupOpen(false);
    };

    const closeVideoPopup = () => {
        setVideoPopupOpen(false);
    };

    if (!gallery || gallery?.length === 0) return null

    return (
        <>
            <div className="sm:px-0 px-2">
                <button className="mt-2 py-1 px-2 border border-third rounded-md text-third font-bold" onClick={() => openPopup(0)}>{dictionary.floorPlans} ({gallery.length})</button>
            </div>
            <Gallery isOpen={isPopupOpen} onClose={closePopup} gallery={gallery} initialSlide={activeSlide} altName={altName} />
        </>
    )
}

export default PropertyFloorplansGallery